import { listAllAlarmsByHabitatQuery } from '@akin-home/alarms/frontend';
import { listAllAlertsByHabitatQuery } from '@akin-home/alerts/frontend';
import { CalendarItemType } from '@akin-home/amplify';
import { notNullOrUndefined } from '@akin-home/arrays';
import { listAllEventsByHabitatQuery } from '@akin-home/events/frontend';
import { formatCalendarItemToModel } from '../functions';

interface Params {
  types?: CalendarItemType[];

  query: {
    habitatID: string;
    filter: { from: string; to: string };
  };
}

export const listCalendarItems = async (params: Params) => {
  const {
    query: { habitatID, filter },
  } = params;

  const types = params.types || [
    CalendarItemType.Event,
    CalendarItemType.Alert,
    CalendarItemType.Alarm,
  ];

  const queries = types
    .map((type) => {
      if (type === CalendarItemType.Event) {
        return listAllEventsByHabitatQuery(habitatID, filter);
      }

      if (type === CalendarItemType.Alert) {
        return listAllAlertsByHabitatQuery(habitatID, filter);
      }

      if (type === CalendarItemType.Alarm) {
        return listAllAlarmsByHabitatQuery(habitatID, filter);
      }

      return;
    })
    .filter(notNullOrUndefined);

  return (await Promise.all(queries)).flat().map(formatCalendarItemToModel);
};
